module.exports = __webpack_public_path__ + "img/fstbg.b2d5ce4c.jpg";